//to confirm patch dates see
//https://status.robertsspaceindustries.com/
//https://robertsspaceindustries.com/spectrum/community/SC/forum/190048?page=1&sort=hot
//https://starcitizen.tools/Category:Upcoming_Patches

const latestVersion = "3.10.2";

const allStarCitizenVersions = [
    { version: "3.10.2", date: "2020-08-24" }
];

const starCitizen = {
    currentVersion: allStarCitizenVersions.find((v) => v.version === latestVersion)
}

export { allStarCitizenVersions };
export default starCitizen;